import { Amplify } from "aws-amplify";

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_CONFIG_POOL_ID,
            userPoolClientId: import.meta.env.VITE_CONFIG_CLIENT_ID,
            loginWith: {
                email: true,
            },
        },
    },
});